import sortAlphabetical from '@/root/utils/helpers/sortAlphabetical'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'
import { Fragment, useContext, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'
import { UserContext } from '../../context/UserContext'

// Internal components

const FormItemSwaplist = (props) => {
  const { item } = props
  const userContext = useContext(UserContext)
  const { t } = useTranslation(userContext.sportTypes)
  
  const { register, unregister } = useFormContext()
  const [presentArr, setPresentArr] = useState([])
  const [absentArr, setAbsentArr] = useState([])

  const sortByType = (a, b) => (a.type > b.type ? -1 : 1)
  const moveToAbsent = (player) => {
    const longerArr = [...absentArr]
    longerArr.push(player)
    const shorterArr = [...presentArr].filter((el) => {
      return el.uuid !== player.uuid
    })
    const sortedPlayerArr = shorterArr.sort(sortByType)
    setPresentArr(sortedPlayerArr)
    setAbsentArr(sortAlphabetical(longerArr))
  }

  const moveToPresent = (player) => {
    const longerArr = [...presentArr]
    longerArr.push(player)
    const shorterArr = [...absentArr].filter((el) => {
      return el.uuid !== player.uuid
    })
    const sortedPlayerArr = longerArr.sort(sortByType)
    setPresentArr(sortedPlayerArr)
    setAbsentArr(sortAlphabetical(shorterArr))
    unregister(`absentPlayer::${player.uuid}`)
  }

  useEffect(() => {
    if (item.absentList) {
      let playerArr

      // Data model is different when going back in the modal.
      if (item.currentLineUp?.[0]?.uuid) {
        playerArr = [...item.initialLineUp].filter(
          (player) => !item.currentLineUp.find((initialPlayer) => initialPlayer.uuid === player.uuid)
        )
      } else {
        // Also filter the absents from the list
        playerArr = [...item.initialLineUp]
          .filter((player) => !item.currentLineUp.includes(`${player.name}::${player.uuid}`))
          .filter((player) => !item.absentList.find((absentPlayer) => player.uuid === absentPlayer.uuid))
      }
      const sortedPlayerArr = playerArr.sort(sortByType)
      setPresentArr(sortedPlayerArr)
      setAbsentArr(sortAlphabetical(item.absentList))
    } else {
      const playerArr = [...item.initialLineUp].filter(
        (player) => !item.currentLineUp.includes(`${player.name}::${player.uuid}`)
      )
      const sortedPlayerArr = playerArr.sort(sortByType)
      setPresentArr(sortedPlayerArr)
    }
  }, [])

  return (
    <div className="FormItem FormItem--swaplist">
      <>
        <h3 className="FormItem--swaplistSubtitle"> {t('MDL__TXT_SUBSTITUTES')} </h3>
        {presentArr.length !== 0 && presentArr.length ? (
          <ul className="FormItem--swaplistList FormItem--present">
            {presentArr?.map((player, index) => {
              return (
                <li
                  className="FormItem--swaplistPlayer"
                  onClick={() => (player.type !== 'guest' ? moveToAbsent(player) : '')}
                  key={uuidv4()}
                >
                  <span className="FormItem--swaplistPlayerName">{player.name}</span>
                  {player.type !== 'guest' && (
                    <span className="FormItem--swaplistButton"> {t('MDL__TXT_MARK_ABSENT')} </span>
                  )}
                </li>
              )
            })}
          </ul>
        ) : (
          <span className="FormItem--swaplistEmpty"> {t('MDL__TXT_NO_PRESENT')}</span>
        )}
      </>
      <>
        <h3 className="FormItem--swaplistSubtitle"> {t('MDL__TXT_ABSENT')} </h3>
        {absentArr.length !== 0 && absentArr.length ? (
          <ul className="FormItem--swaplistList FormItem--absent">
            {absentArr?.map((player, index) => {
              return (
                <li className="FormItem--swaplistPlayer" onClick={() => moveToPresent(player)} key={uuidv4()}>
                  <span className="FormItem--swaplistPlayerName">{player.name}</span>
                  <span className="FormItem--swaplistButton"> {t('MDL__TXT_MARK_PRESENT')} </span>
                </li>
              )
            })}
          </ul>
        ) : (
          <span className="FormItem--swaplistEmpty"> {t('MDL__TXT_NO_ABSENT')}</span>
        )}
      </>
      {absentArr.map((player) => {
        return (
          <input
            type="hidden"
            id={`absentPlayer::${player.uuid}`}
            name={`absentPlayer::${player.uuid}`}
            className="FormItem-input"
            value={`${player.uuid}`}
            key={uuidv4()}
            {...register(`absentPlayer::${player.uuid}`)}
          />
        )
      })}
      {presentArr?.map((player) => {
        if (player.type !== 'guest') return <Fragment key={uuidv4()}></Fragment>
        return (
          <input
            type="hidden"
            id={`guestPlayer::${player.uuid}::${player.name}`}
            name={`guestPlayer::${player.uuid}::${player.name}`}
            className="FormItem-input"
            value={`${player.uuid}::${player.name}`}
            key={uuidv4()}
            {...register(`guestPlayer::${player.uuid}::${player.name}`)}
          />
        )
      })}
    </div>
  )
}

FormItemSwaplist.propTypes = {
  item: PropTypes.object
}

export default FormItemSwaplist
